import { render, staticRenderFns } from "./app-sleep.vue?vue&type=template&id=6867d0ed&scoped=true&"
import script from "./app-sleep.vue?vue&type=script&lang=ts&"
export * from "./app-sleep.vue?vue&type=script&lang=ts&"
import style0 from "./app-sleep.vue?vue&type=style&index=0&id=6867d0ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867d0ed",
  null
  
)

export default component.exports